module.exports = __webpack_public_path__ + "img/sdg6_jp.de5b2ec6.png";